<ng-container *ngIf="languages && languages.length > 0">


<button mat-button fxFlex="0 1 100%" class="language-button" [matMenuTriggerFor]="languageMenu" (click)="$event.stopPropagation();">
    <div class="h-100-p p-12" fxLayout="row wrap" fxLayoutAlign="center flex-end">

        <ng-container *ngIf="orientation=='up'">
            <mat-icon fxFlex="100%" class="s-16 white-text">keyboard_arrow_up</mat-icon>
            <span class="iso" *ngIf="loading">{{selectedLanguage.description}}</span>        </ng-container>
        <ng-container *ngIf="orientation=='down'">
            <span fxFlex="100%" class="iso" *ngIf="loading">{{selectedLanguage.description}}</span>
            <mat-icon *ngIf="orientation=='down'" fxFlex="100%" class="s-16 white-text">keyboard_arrow_down</mat-icon>
        </ng-container>

    </div>
</button>
    <mat-menu #languageMenu="matMenu" [overlapTrigger]="false">
        <button mat-menu-item *ngFor="let lang of languages" (click)="setLanguage(lang)">
            <span fxLayout="row" fxLayoutAlign="start center">
                <span class="iso" *ngIf="loading">{{lang.description}}</span>
            </span>
        </button>
    </mat-menu>
</ng-container>

